/** Nästa 13 september (valdagen) i lokal tid; antal hela kalenderdagar från idag till det datumet (0 om det är valdagen). */
export function daysUntilNextValdagen(now: Date): number {
    const y = now.getFullYear();
    const m = now.getMonth();
    const d = now.getDate();
    let targetY = y;
    let target = new Date(targetY, 8, 13);
    const todayStart = new Date(y, m, d).getTime();
    if (todayStart > target.getTime()) {
        targetY = y + 1;
        target = new Date(targetY, 8, 13);
    }
    return Math.round((target.getTime() - todayStart) / 86400000);
}

export function electionDayDailyTarget(
    yearGoal: number,
    deliveredThisCalendarYear: number,
    now: Date
): { dailyTarget: number; remaining: number; daysLeft: number } | null {
    const remaining = Math.max(0, yearGoal - deliveredThisCalendarYear);
    let daysLeft = daysUntilNextValdagen(now);
    if (daysLeft < 1) {
        daysLeft = 1;
    }
    if (remaining <= 0) {
        return null;
    }
    const dailyTarget = Math.max(1, Math.ceil(remaining / daysLeft));
    return { dailyTarget, remaining, daysLeft };
}
